import {
    USER_COURSES_INFO_CHANGED,
    USER_COURSES_OPERATION_START,
    USER_COURSES_OPERATION_FINISH,
    USER_COURSES_OPERATION_FAIL,
    USER_GET_ALL_COURSES,
    USER_GET_ALL_COURSES_PROGRESS,
    USER_CLEAR_COURSES_DATA,
    USER_SELECT_COURSE,
    USER_GET_COURSE_STRUCT_START,
    USER_GET_COURSE_STRUCT,
    USER_GET_COURSE_EXAMS,
    USER_GET_COURSE_STRUCT_FAIL,
    USER_GET_COURSE_STRUCT_FINISH
} from '../../actions/types';

const INITIAL_STATE = {
    courses: [],
    error: '',
    loading: false,
    selectedCourse: null,
    selectedCourseStruct: [],
    selectedCourseExams: [],
    selectedCourseExamsCourseId: null,
    selectedCourseStructCourseId: null,
    selectedCourseStructRequestId: null,
    selectedCourseStructLoading: false,
    selectedCourseStructError: ''
};

const injectCoursesProgress = (courses, progress) => {
    const newData = structuredClone(courses);
    for (let c of newData) {
        for (let p of progress)
            if (c.id === p.courseId)
                c.courseProgress = p.progress;
    }

    return newData;
};

const isSelectedCourseRequest = (state, action) => Boolean(state.selectedCourse)
    && String(action.meta?.courseId) === String(state.selectedCourse.id);
const isCurrentStructureRequest = (state, action) => isSelectedCourseRequest(state, action)
    && action.meta?.requestId === state.selectedCourseStructRequestId;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USER_COURSES_INFO_CHANGED:
            return { ...state, [action.payload.props]: action.payload.value };
        case USER_COURSES_OPERATION_START:
            return { ...INITIAL_STATE, loading: true, selectedCourseStructError: '' };
        case USER_COURSES_OPERATION_FINISH:
            return { ...state, loading: false };
        case USER_COURSES_OPERATION_FAIL:
            return { ...state, error: { [action.payload.props]: action.payload.value } };
        case USER_GET_ALL_COURSES:
            return { ...state, courses: action.payload };
        case USER_GET_ALL_COURSES_PROGRESS:
            return { ...state, courses: injectCoursesProgress(state.courses, action.payload) };
        case USER_SELECT_COURSE:
            return { ...state, selectedCourse: action.payload, selectedCourseStruct: [],
                selectedCourseExams: [], selectedCourseExamsCourseId: null,
                selectedCourseStructCourseId: null, selectedCourseStructRequestId: null,
                selectedCourseStructLoading: false, selectedCourseStructError: '' };
        case USER_GET_COURSE_STRUCT_START:
            if (!isSelectedCourseRequest(state, action)) return state;
            return { ...state, selectedCourseStructRequestId: action.meta.requestId,
                selectedCourseStructLoading: !action.meta.withoutLoad, selectedCourseStructError: '' };
        case USER_GET_COURSE_STRUCT_FINISH:
            if (!isCurrentStructureRequest(state, action)) return state;
            return { ...state, selectedCourseStructLoading: false };
        case USER_GET_COURSE_STRUCT_FAIL:
            if (!isCurrentStructureRequest(state, action)) return state;
            return { ...state, selectedCourseStructError: { [action.payload.props]: action.payload.value } };
        case USER_GET_COURSE_EXAMS:
            if (!isCurrentStructureRequest(state, action)) return state;
            return { ...state, selectedCourseExams: action.payload, selectedCourseExamsCourseId: action.meta.courseId };
        case USER_GET_COURSE_STRUCT:
            if (!isCurrentStructureRequest(state, action)) return state;
            return { ...state, selectedCourseStruct: action.payload, selectedCourseStructCourseId: action.meta.courseId,
                selectedCourseExams: action.payload.allowedExams, selectedCourseExamsCourseId: action.meta.courseId };
        case USER_CLEAR_COURSES_DATA:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
};

